import React from "react";
import OrderedModuleEditor from "@/components/common/OrderedModuleEditor";
import MediaImageField from "@/components/common/MediaImageField";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const Field = ({ label, children }) => (
  <div className="space-y-1">
    <Label className="text-xs text-white/50">{label}</Label>
    {children}
  </div>
);

export default function ClientLogos() {
  return (
    <OrderedModuleEditor
      resource="admin/site/logos"
      singular="logo"
      title="Client Logos"
      subtitle="Drag to reorder industry and partner labels. Upload a logo image when available."
      titleKey="name"
      defaultValues={{ order: 1, name: "", image: "", status: "published" }}
      enableStatus
      getItemLabel={(it, idx) => it.name || `Logo ${idx + 1}`}
      renderPreviewItem={(it) => (
        <div className="flex items-center gap-3">
          {(it.image || it.logo_url) ? (
            <img src={it.image || it.logo_url} alt="" className="w-10 h-10 rounded object-contain bg-white/10 p-1" />
          ) : (
            <div className="w-10 h-10 rounded-full glass flex items-center justify-center text-[10px] text-white/50">TXT</div>
          )}
          <span className="text-sm font-medium text-white">{it.name || "Untitled"}</span>
        </div>
      )}
      renderInspector={(item, patch) => (
        <>
          <Field label="Name">
            <Input value={item.name || ""} onChange={(e) => patch({ name: e.target.value })} className="bg-black/20 border-white/10 text-white" />
          </Field>
          <MediaImageField
            label="Logo Image"
            value={item.image || item.logo_url || ""}
            onChange={(url) => patch({ image: url })}
            folder="logos"
            aspectClass="h-28"
            hint="Optional. Falls back to the name text on the site."
          />
        </>
      )}
    />
  );
}
